{
  "name": "HS 53°-106°: harmonic partial row from 53° to 106°",
  "description": "A 53-tone one octave cycle comprising the harmonic partial row from 53° to 106°. 54° (Degree 1) is tuned to A 220 Hz, so the fundamental pitch-class (1°, 2°, 4°, 8°, 16°, etc.) is Pythagorean C. The central degree is 11 (1°). The entire series may be transposed to any fundamental by changing the Reference Frequency and Degree.",
  "scale": [
    "54/53",
    "55/53",
    "56/53",
    "57/53",
    "58/53",
    "59/53",
    "60/53",
    "61/53",
    "62/53",
    "63/53",
    "64/53",
    "65/53",
    "66/53",
    "67/53",
    "68/53",
    "69/53",
    "70/53",
    "71/53",
    "72/53",
    "73/53",
    "74/53",
    "75/53",
    "76/53",
    "77/53",
    "78/53",
    "79/53",
    "80/53",
    "81/53",
    "82/53",
    "83/53",
    "84/53",
    "85/53",
    "86/53",
    "87/53",
    "88/53",
    "89/53",
    "90/53",
    "91/53",
    "92/53",
    "93/53",
    "94/53",
    "95/53",
    "96/53",
    "97/53",
    "98/53",
    "99/53",
    "100/53",
    "101/53",
    "102/53",
    "103/53",
    "104/53",
    "105/53",
    "106/53"
  ],
  "key_colors_mode": "manual",
  "short_description": "53-HS_53to106",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "note_names": [
    "53°",
    "27°",
    "55°",
    "7",
    "57",
    "29",
    "59",
    "15",
    "61",
    "31",
    "63",
    "1",
    "65",
    "33",
    "67",
    "17",
    "69",
    "35",
    "71",
    "9",
    "73",
    "37",
    "75",
    "19",
    "77",
    "39",
    "79",
    "5",
    "81",
    "41",
    "83",
    "21",
    "85",
    "43",
    "87",
    "11",
    "89",
    "45",
    "91",
    "23",
    "93",
    "47",
    "95",
    "3",
    "97",
    "49",
    "99",
    "25",
    "101",
    "51",
    "103",
    "13",
    "105",
    "53"
  ],
  "note_colors": [
    "#ff8b8b",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#d6f7ff",
    "#b6ece3",
    "#e5adff",
    "#fffae5",
    "#ededed",
    "#68f3ec",
    "#ffe5e5",
    "#ffffff",
    "#e9d7d3",
    "#dfffd6",
    "#ededed",
    "#cfcfcf",
    "#95c69b",
    "#ffcba8",
    "#ededed",
    "#ffffff",
    "#ededed",
    "#cee3e2",
    "#fef5be",
    "#d6f7ff",
    "#e9ecc1",
    "#e6d7fe",
    "#ededed",
    "#fffae5",
    "#ffffff",
    "#d39e92",
    "#ededed",
    "#ffe5e5",
    "#eceae4",
    "#dee2da",
    "#8aafff",
    "#dfffd6",
    "#ededed",
    "#fffae5",
    "#ebd0e0",
    "#95c69b",
    "#68f3ec",
    "#ffb8da",
    "#e5fff9",
    "#ffffff",
    "#ededed",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#ededed",
    "#cfcfcf",
    "#ededed",
    "#e6d7fe",
    "#ffcba8",
    "#ededed"
  ],
  "equivSteps": 53,
  "fundamental": 220,
  "reference_degree": 1,
  "center_degree": 11,
  "rSteps": 9,
  "drSteps": 4,
  "hexSize": 32,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
